"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const index_1 = __importDefault(require("lodash/index"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const Footnotes_1 = require("../../components/Footnotes");
const Sources_1 = require("../../components/Sources");
const Tooltip_1 = __importDefault(require("../../components/Tooltip"));
const styles_module_css_1 = __importDefault(require("../../components/Tooltip/styles.module.css"));
const utilities_1 = require("../../utilities");
const date_1 = require("../../utilities/date");
const types_1 = require("../../utilities/types");
const constants_1 = require("../BarChart/constants");
const model_1 = require("./model");
const validate_1 = require("./model/validate");
require("./styles.css");
const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
const MIN_HEIGHT = 200;
const DEFAULT_MARGINS = {
  top: 20,
  left: 0,
  right: 0,
  bottom: 0
};
const SankeyVertical = _ref => {
  let {
    data: rawData,
    height,
    hideFooter = false,
    levels,
    levelsLabelWidth,
    linkHeight = 55,
    links,
    margins: rawMargins = DEFAULT_MARGINS,
    nodeHeight = 40,
    nodes,
    sortDropdowns = true,
    subtitle,
    title,
    titleFontSize,
    tooltipStyle = {},
    width,
    categoryCallback = () => {},
    customTooltip = (values, category, color) => {
      const {
        formattedValue
      } = values.find(_ref2 => {
        let {
          name
        } = _ref2;
        return name === category;
      }) || {};
      return react_1.default.createElement("div", {
        className: styles_module_css_1.default['tooltip-grid']
      }, formattedValue && react_1.default.createElement("div", {
        className: styles_module_css_1.default['tooltip-row']
      }, react_1.default.createElement("div", {
        className: styles_module_css_1.default['tooltip-value'],
        style: {
          color
        }
      }, formattedValue)));
    },
    dateCallback = () => {},
    hoverCallback = () => {}
  } = _ref;
  if (height && height < MIN_HEIGHT) {
    console.warn(`Height cannot be lower than ${MIN_HEIGHT}.`);
  }
  const dataIdsString = (0, utilities_1.getDataIds)(rawData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = (0, react_1.useMemo)(() => (0, utilities_1.extractDatasets)(rawData), [dataIdsString]);
  const requiredProps = [levels, nodes, links, data, width];
  const categories = (0, model_1.getCategories)(links);
  const dates = (0, model_1.getDates)(data);
  const margins = {
    ...DEFAULT_MARGINS,
    ...rawMargins
  };
  const [category, setCategory] = (0, react_1.useState)(categories === null || categories === void 0 ? void 0 : categories[0]);
  const dropdownType = (0, utilities_1.getAxisTypeFromData)(data, 'x');
  const dropdownFormat = (0, react_1.useMemo)(() => (0, utilities_1.valueFormat)({
    params: {
      format: dropdownType || constants_1.DEFAULT_DROPDOWN_TYPE
    }
  }), [dropdownType]);
  const keys = (0, react_1.useMemo)(() => (0, utilities_1.extractKeys)(data, date_1.dateParser).map(i => ({
    ...i,
    parsed: dropdownFormat(i.key)
  })),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString, dropdownType]);
  const {
    key: date,
    setKey: setDate,
    dropdown
  } = (0, utilities_1.useDropdown)({
    enabled: true,
    keys,
    label: title ? ' ' : '',
    parser: dropdownFormat,
    sortBy: sortDropdowns,
    targetKey: null
  });
  const [tooltip, setTooltip] = (0, react_1.useState)({
    position: {
      x: null,
      y: null
    },
    node: null
  });
  const throttledSetTooltip = (0, react_1.useMemo)(() => index_1.default.debounce(innerTooltip => {
    hoverCallback(innerTooltip.node);
    setTooltip(innerTooltip);
  }, 33),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const dropdowns = [{
    ...dropdown,
    onChange: _ref3 => {
      let {
        target: {
          value
        }
      } = _ref3;
      const parsedKey = keys.find(_ref4 => {
        let {
          parsed
        } = _ref4;
        return parsed === value;
      });
      if (parsedKey && parsedKey.key) {
        setDate(parsedKey.key);
        dateCallback(parsedKey.key);
      }
    }
  }, {
    options: categories,
    label: ' ',
    value: category,
    onChange: _ref5 => {
      let {
        target: {
          value
        }
      } = _ref5;
      setCategory(value);
      categoryCallback(value);
    }
  }];
  let footerSources = [];
  let footerSummary;
  let footnotes = [];
  const sources = (0, Sources_1.useSources)({
    data
  });
  const footerFootnotes = (0, Footnotes_1.useFootnotes)({
    data
  });
  if (!hideFooter) {
    footerSources = sources.sources;
    footerSummary = sources.summary;
    footnotes = footerFootnotes.footnotes;
  }
  if (isEmpty(categories) || isEmpty(dates) || (dates === null || dates === void 0 ? void 0 : dates.slice(-1)) === undefined || !isEmpty((0, validate_1.validateNodes)(nodes)) || !isEmpty((0, validate_1.validateLevels)(levels, nodes)) || !isEmpty((0, validate_1.validateLinks)(links, nodes, levels)) || requiredProps.some(prop => prop === null || prop === undefined)) {
    return null;
  }
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: "vertical-sankey",
    title: title,
    subtitle: subtitle,
    titleFontSize: titleFontSize,
    dropdowns: dropdowns,
    footerSources: footerSources,
    footerSummary: footerSummary,
    footnotes: footnotes,
    showFooter: !hideFooter,
    width: width,
    height: height
  }, _ref6 => {
    let {
      chartWidth,
      chartHeight
    } = _ref6;
    let nh = nodeHeight;
    if (height) {
      nh = (chartHeight - margins.top - margins.bottom) / (levels.length * 2 - 1);
    }
    let lh = linkHeight;
    if (height) {
      lh = nh;
    }
    const positions = (0, model_1.getLayouts)(data, levels, links, nodes, width, nh, lh, category, date, levelsLabelWidth, margins);
    const minChartHeight = (nh + lh) * levels.length - lh + margins.top;
    const minChartWrapperHeight = minChartHeight + margins.bottom;
    return react_1.default.createElement("div", {
      style: {
        height: chartHeight,
        minHeight: minChartWrapperHeight,
        position: 'relative',
        width: '100%'
      }
    }, react_1.default.createElement("svg", {
      width: chartWidth,
      height: minChartHeight,
      style: {
        marginRight: margins.right,
        marginBottom: margins.bottom,
        marginLeft: margins.left
      }
    }, react_1.default.createElement(NodesLayout, {
      nodes: positions.nodes,
      throttledSetTooltip: throttledSetTooltip
    }), react_1.default.createElement(LinkLayout, {
      links: Object.values(positions.links)
    }), react_1.default.createElement(LevelsLayout, {
      levels: positions.levels
    })), !index_1.default.isNil(tooltip.position.x) && !index_1.default.isNil(tooltip.position.y) &&
    // eslint-disable-next-line react/jsx-props-no-spreading
    react_1.default.createElement(Tooltip_1.default, {
      ...tooltip.position,
      style: tooltipStyle,
      width: width
    }, react_1.default.createElement("div", null, react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-title']
    }, (0, model_1.getNodeLevelTitle)(tooltip.node, levels)), react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-subtitle']
    }, (0, model_1.getNodeSubtitle)(tooltip.node, category, nodes, levels)), react_1.default.createElement("div", {
      className: styles_module_css_1.default['tooltip-title']
    }, date), customTooltip((0, model_1.getNodeValues)(tooltip.node, (0, model_1.findDateFromString)(dates, date), links, data), category, index_1.default.find(positions.nodes, _ref7 => {
      let {
        id
      } = _ref7;
      return id === tooltip.node;
    }).color, (0, model_1.getNodeValues)((0, model_1.getParentNodeID)(tooltip.node, links), (0, model_1.findDateFromString)(dates, date), links, data)))));
  });
};
const NodesLayout = _ref8 => {
  let {
    nodes,
    throttledSetTooltip
  } = _ref8;
  return nodes.map(_ref9 => {
    let {
      x,
      y,
      width: nodesLayoutWidth,
      height,
      label,
      color
    } = _ref9;
    return {
      x,
      y,
      width: nodesLayoutWidth,
      height,
      label,
      color,
      textX: x + nodesLayoutWidth / 2,
      textY: y + height / 2
    };
  }).map((_ref10, i) => {
    let {
      x,
      y,
      width: containerWidth,
      height: containerHeight,
      label,
      color,
      textX,
      textY
    } = _ref10;
    return (
      // eslint-disable-next-line react/no-array-index-key
      react_1.default.createElement("g", {
        className: "node",
        key: `nodes-layout-${i}`
      }, react_1.default.createElement("rect", {
        x: x,
        y: y,
        width: containerWidth,
        height: containerHeight,
        fill: color,
        onMouseOver: event => {
          if (event && event.target && event.target.ownerSVGElement) {
            if (nodes.length <= i) {
              return;
            }
            const hoveredNode = nodes[i].id;
            throttledSetTooltip({
              position: {
                x: x + containerWidth / 2,
                y: y + containerHeight
              },
              node: hoveredNode
            });
          } else {
            throttledSetTooltip({
              position: {
                x: null,
                y: null
              },
              node: null
            });
          }
        },
        onMouseOut: () => {
          throttledSetTooltip({
            position: {
              x: null,
              y: null
            },
            node: null
          });
        }
      }), react_1.default.createElement("text", {
        x: textX,
        y: textY,
        dy: "0.35em"
      }, label))
    );
  });
};
const LinkLayout = _ref11 => {
  let {
    links
  } = _ref11;
  return links.map((_ref12, i) => {
    let {
      color,
      d
    } = _ref12;
    return react_1.default.createElement("path", {
      className: "link",
      fill: color,
      key: `link-layout-${(d === null || d === void 0 ? void 0 : d.id) || i}`,
      d: d
    });
  });
};
const LevelsLayout = _ref13 => {
  let {
    levels
  } = _ref13;
  return levels.map(_ref14 => {
    let {
      x,
      y,
      width: levelPositionWidth,
      height: levelPositionHeight,
      ...rest
    } = _ref14;
    return {
      ...rest,
      width: levelPositionWidth,
      labelY: levelPositionHeight / 2,
      levelTransform: `translate(${x},${y})`
    };
  }).map((_ref15, i) => {
    let {
      title: levelsLayoutTitle,
      label,
      width: levelWidth,
      labelY,
      levelTransform
    } = _ref15;
    return react_1.default.createElement("g", {
      className: "level-labels",
      transform: levelTransform,
      // eslint-disable-next-line react/no-array-index-key
      key: `levelsLayout-${i}`
    }, (levelsLayoutTitle === null || levelsLayoutTitle === void 0 ? void 0 : levelsLayoutTitle.lastPosition) !== '' && react_1.default.createElement("g", {
      className: "level-title"
    }, react_1.default.createElement("text", {
      dy: "-7px"
    }, levelsLayoutTitle), react_1.default.createElement("line", {
      x1: "0",
      x2: levelWidth
    })), react_1.default.createElement("text", {
      y: labelY,
      dy: "0.35em"
    }, label));
  });
};
NodesLayout.propTypes = {
  nodes: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    x: prop_types_1.number,
    y: prop_types_1.number,
    width: prop_types_1.number,
    height: prop_types_1.number,
    label: prop_types_1.string,
    color: prop_types_1.string,
    textX: prop_types_1.number,
    textY: prop_types_1.number
  })),
  throttledSetTooltip: prop_types_1.func
};
LinkLayout.propTypes = {
  links: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    color: prop_types_1.string,
    topLeft: prop_types_1.number,
    topRight: prop_types_1.number,
    bottomLeft: prop_types_1.number,
    bottomRight: prop_types_1.number
  }))
};
LevelsLayout.propTypes = {
  levels: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    title: prop_types_1.string,
    label: prop_types_1.string,
    width: prop_types_1.number,
    labelY: prop_types_1.number,
    levelTransform: prop_types_1.string
  }))
};
SankeyVertical.propTypes = {
  ...ChartWrapper_1.chartWrapperPropTypes,
  /**
   * Height to draw the chart. This will be auto calculated if not set
   */
  height: prop_types_1.number,
  /**
   * Width to draw the chart. This will set the width of the SVG.
   */
  width: prop_types_1.number.isRequired,
  /**
   * Height of the node on each level. Defaults to 40(px).
   */
  nodeHeight: prop_types_1.number,
  /**
   * Height of the links between levels. Defaults to 55(px).
   */
  linkHeight: prop_types_1.number,
  /**
   * Width to use for the left labels of the sankey.
   */
  levelsLabelWidth: prop_types_1.number,
  /**
   * Levels of the sankey.
   * Defines the labels on the left of the sankey and the order of the nodes in each level.
   * The strings in the `nodes` array should match `id`s in the component's `nodes` property.
   */
  levels: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    title: prop_types_1.string,
    label: prop_types_1.string,
    nodes: (0, prop_types_1.arrayOf)(prop_types_1.string).isRequired
  })).isRequired,
  /**
   * Nodes of the sankey.
   * Defines the color and label of the nodes. If no label is specified it will show id instead.
   */
  nodes: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    label: prop_types_1.string,
    color: prop_types_1.string
  })).isRequired,
  /**
   * Links of the sankey
   * Defines the source and target nodes of the sankey links and the associated data.
   * The `id`s of the `metrics` array should match `id`s in the component's `data` property.
   */
  links: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    source: prop_types_1.string.isRequired,
    target: prop_types_1.string.isRequired,
    metrics: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
      name: prop_types_1.string.isRequired,
      id: prop_types_1.string.isRequired,
      unit: prop_types_1.string
    })).isRequired
  })),
  /**
   * Data for the chart
   */
  data: (0, prop_types_1.oneOfType)([(0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /**
   * Margins around the chart
   * Defaults to:
   *  top: 20
   *  bottom: 0
   *  left: 0
   *  right: 0
   */
  margins: (0, prop_types_1.shape)({
    top: prop_types_1.number,
    bottom: prop_types_1.number,
    left: prop_types_1.number,
    right: prop_types_1.number
  }),
  /**
   * Returns custom content for the tooltip.
   *
   * @param {Array} values - values for each category with the selected date for the selected node
   * @param {string} category - the selected category
   * @param {string} color - the color of the selected node
   * @param {Array} parentValues - values for each category with the selected date for the parent of the selected node
   * @returns {ReactElement} - Element to render in the tooltip
   */
  customTooltip: prop_types_1.func,
  /**
   * Gets called when the category dropdown changes.
   *
   * @param {string} category - the selected category
   */
  categoryCallback: prop_types_1.func,
  /**
   * Gets called when the date dropdown changes.
   *
   * @param {string} date - the selected date formatted like in the dropdown
   */
  dateCallback: prop_types_1.func,
  /**
   * Gets called when a node gets hovered.
   *
   * @param {string} nodeID - the ID of the hovered node
   */
  hoverCallback: prop_types_1.func,
  /**
   * Flag to hide sources footer. Defaults to false.
   */
  hideFooter: prop_types_1.bool,
  tooltipStyle: react_style_proptype_1.default,
  /**
   * Sort dropdown values
   */
  sortDropdowns: (0, prop_types_1.oneOfType)([prop_types_1.bool, (0, prop_types_1.oneOf)(['ascending', 'descending'])])
};
exports.default = SankeyVertical;